import { render, staticRenderFns } from "./OrganizationReportsContainer.vue?vue&type=template&id=664d608e&scoped=true"
import script from "./OrganizationReportsContainer.vue?vue&type=script&lang=js"
export * from "./OrganizationReportsContainer.vue?vue&type=script&lang=js"
import style0 from "./OrganizationReportsContainer.vue?vue&type=style&index=0&id=664d608e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664d608e",
  null
  
)

export default component.exports